import { Stack } from "@mui/material"
import React, { useState } from "react"
import UseGetStepHookDucPage from "../UseGetStepHookDucPage"
import PiModal from "./PiModal";
import AIANBlockSteper from "./AIANBlockStepper";
import DUCDeleteModal from "./DUCDeleteModal";
import AIANBlockButtons from "./AIANBlockButtons";
import { useUserInfoQuery } from "../../../api/userApiSlice";
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";



const AIANBlockComponent = () => {

    //We need expiry and expired because we need a different 
    //status chip for each one
    const [activeStepAIAN, setActiveStepAIAN] = useState(0);
    const [expiringAIAN, setExpiringAIAN] = useState(false);
    const [expiredAIAN, setExpiredAIAN] = useState(false);
    const [declinedAIAN, setDeclinedAIAN] = useState(false);
    const [checkedCurrentStatus, setCheckedCurrentStatus] = useState(false)
    const [open, setOpen] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [cancelRefresh, setCancelRefresh] = useState(false)
    const { data: userData } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });
    const ducData = ducDataObject?.AIAN?.[ducDataObject?.AIAN.length - 1]

    UseGetStepHookDucPage(ducData, setActiveStepAIAN, setExpiredAIAN, setExpiringAIAN, setDeclinedAIAN, setCheckedCurrentStatus)


    return (
        <Stack
            component="section"
            aria-labelledby="aian-header"
            flexDirection="column"
            justifyContent="space-between"
            gap={3}
            padding="20px"
            marginBottom="30px"
            sx={{
                backgroundColor: "white"
            }}
        >
            <PiModal open={open} setOpen={setOpen} type="AIAN"/>
            <DUCDeleteModal open={openDeleteModal} setOpen={setOpenDeleteModal} type="AIAN" />
            <AIANBlockButtons
                expired={expiredAIAN}
                expiring={expiringAIAN}
                setOpen={setOpen}
                setCancelRefresh={setCancelRefresh}
                cancelRefresh={cancelRefresh}
                setOpenDeleteModal={setOpenDeleteModal}
                checkedCurrentStatus={checkedCurrentStatus}/>

            <Stack>
                {ducDataObject?.AIAN.map((ducData: any, index: number) => {
                    return (
                        <AIANBlockSteper
                            ducData={ducData}
                            declinedAIAN={declinedAIAN}
                            expiredAIAN={expiredAIAN}
                            key={index}
                            index={index}
                            activeStepAIAN={activeStepAIAN}/>
                    )
                })}
            </Stack>
        </Stack>
    )


}

export default AIANBlockComponent